"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadPatientFile = exports.uploadFile = exports.parseFileType = exports.getAccept = void 0;
var fetchUtils_1 = require("./fetchUtils");
var apiUrls_1 = __importDefault(require("./apiUrls"));
var constants_1 = require("./constants");
var getAccept = function (type) {
    switch (type) {
        case constants_1.fileTypes.image:
            return 'image/jpg,image/jpeg,image/png,image/gif';
        case constants_1.fileTypes.audio:
            return 'audio/mp3';
        case constants_1.fileTypes.video:
            return 'video/mp4';
        case constants_1.fileTypes.document:
            return 'application/pdf';
        case 'data':
            return 'application/json';
        default:
            return 'image/jpg,image/jpeg,image/png,image/gif,audio/mp3,video/mp4,application/pdf';
    }
};
exports.getAccept = getAccept;
var parseFileType = function (fileType) {
    if (!fileType) {
        return constants_1.fileTypes.file;
    }
    if (fileType.indexOf('image') >= 0) {
        return constants_1.fileTypes.image;
    }
    if (fileType.indexOf('audio') >= 0) {
        return constants_1.fileTypes.audio;
    }
    if (fileType.indexOf('video') >= 0) {
        return constants_1.fileTypes.video;
    }
    if (fileType.indexOf('application') >= 0) {
        return constants_1.fileTypes.document;
    }
    return constants_1.fileTypes.file;
};
exports.parseFileType = parseFileType;
var uploadFile = function (file, fileType, config, programId) {
    var type = fileType || (0, exports.parseFileType)(file.type);
    var formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    var url = "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.portal.media, "/").concat(type);
    if (programId)
        url += "?programId=".concat(programId);
    var maxUploadSize = ((config === null || config === void 0 ? void 0 : config.maxUploadSizeMB) || 500) * 1024 * 1024; // default 500 MB if not set in config
    var maxNonStreamingSize = ((config === null || config === void 0 ? void 0 : config.maxNonStreamingUploadSizeMB) || 40) * 1024 * 1024; // default 40 MB if not set in config
    if (file.size > maxUploadSize) {
        return Promise.reject(new Error('930'));
    }
    if (file.size > maxNonStreamingSize) {
        // using streaming upload
        formData.append('fileName', file.name);
        formData.append('contentType', file.type);
        formData.append('programId', programId);
        url = "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.portal.media);
    }
    return (0, fetchUtils_1.youwellFetch)(url, {
        method: 'POST',
        body: formData,
    })
        .then((0, fetchUtils_1.handleErrors)())
        .then(fetchUtils_1.json)
        .then(function (data) { return Promise.resolve(__assign({}, data)); })
        .catch(function (error) { return Promise.reject(new Error((0, fetchUtils_1.getErrorMessageOrKey)(error))); });
};
exports.uploadFile = uploadFile;
var uploadPatientFile = function (file, config) {
    var maxUploadSize = ((config === null || config === void 0 ? void 0 : config.maxUploadSizeMB) || 100) * 1024 * 1024; // default 100 MB if not set in config
    if (file.size > maxUploadSize) {
        return Promise.reject(new Error('930'));
    }
    var type = (0, exports.parseFileType)(file.type);
    var formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('fileName', file.name);
    formData.append('contentType', file.type);
    var url = "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.app.media);
    return (0, fetchUtils_1.youwellFetch)(url, {
        method: 'POST',
        body: formData,
    })
        .then((0, fetchUtils_1.handleErrors)())
        .then(fetchUtils_1.json)
        .then(function (data) { return Promise.resolve(data); })
        .catch(function (error) { return Promise.reject(new Error((0, fetchUtils_1.getErrorMessageOrKey)(error))); });
};
exports.uploadPatientFile = uploadPatientFile;
